import {  Text } from '@blueprintjs/core'
import { FaTrashAlt } from 'react-icons/fa'
import * as con from "../../GlobalConstants"
import { contactAdvisor } from '../../utils/emailFunctions'
import { formatPhoneNumber } from '../../utils/translateFunctions'
import { buildWhatsAppContactFunction } from '../../utils/whatsAppFunctions'
import logo from "./../../img/whatsapp_logo.png"
import { IsStaff } from '../hooks/AuthenticationHook'
import AdvisorRadio from './AdvisorRadio'
import { useDispatch } from 'react-redux'
import { deleteAdvisor } from '../../store/slices/advisorsSlice'


function Advisor({advisor}) {

    // Is Staff
  const isStaff = IsStaff()
  const dispatch = useDispatch()


  return (
    <div>
        <h3 style={{marginBottom : "3px"}}>{advisor[con.NAME]} {isStaff && <FaTrashAlt style={{cursor: "pointer", marginLeft : "5px"}}
                                                                                                        onClick={() => dispatch(deleteAdvisor(advisor[con.ID]))}
                                                                                                        title="Eliminar"/>   }</h3> 
        <Text className="active" onClick={buildWhatsAppContactFunction(advisor[con.PHONE_NUMBER])}> <img src={logo} alt="Logo" width="auto" height={12}/> <strong>Telefono: </strong>{formatPhoneNumber(advisor[con.PHONE_NUMBER])}</Text>
        <Text className="active" onClick={() => contactAdvisor(advisor[con.EMAIL])}><strong>Email: </strong>{advisor[con.EMAIL]}</Text>
        <AdvisorRadio advisorId={advisor[con.ID]} />
        </div>
  )
}


export default Advisor